<div class="rounded-top p-3">
    <ng-container *ngIf="!data.isDeleteModal">
        <div class="d-flex justify-content-between align-items-center w-100">
            <h5 class="modal-title fw-bold mb-0" [innerHTML]="'sub-dashboard-title' | translate"></h5>
            <button class="subscription-close-button" [mat-dialog-close]="true"><i class="icp-icon-40 icp-close d-block"></i></button>
        </div>
        <mat-dialog-content>
            <vfa-cp-contract-payment-card [isAutoRenewal]="true" [isAutorenewalAsset]="true" [isOnboardingPayment]="false" [paymentMethods]="data.paymentMethods" [order]="{}" [orderId]="data.detail.order_id" [assetId]="data.detail.id" [years]="[]" [price]="0" [rest]="0" (onStartPaymentError)="startPaymentError($event)" (onWaitSave)="changeWaitSave($event)" (onWaitStripeLoaded)="changeWaitStripeLoaded($event)" (onCompleteForm)="formCompletedCheck($event)" (onConfirmPayment)="confirmPayment($event)"></vfa-cp-contract-payment-card>
        </mat-dialog-content>
        <!-- <button (click)="confirmAssetSEPA()" [disabled]="waitSave || !waitStripeLoaded || !formCompleted" class="btn btn-primary mt-5 mb-3 w-100">
            <span *ngIf="!waitSave">{{"save-SEPA-autorenewal-button" | translate}}</span>
            <span *ngIf="waitSave">{{"common-waiting" | translate}}</span>
        </button> -->
    </ng-container>
    <ng-container *ngIf="data.isDeleteModal">
        <div class="d-flex justify-content-center">
            <p class="fs-18 mb-5 fw-bold" [innerHTML]="'delete-subscription-modal-text' | translate"></p>
        </div>
        <div class="d-flex w-100 align-items-center justify-content-center">
            <div (click)="unsubscribeService()" class="me-3 c-red cursor-pointer">{{"sub-dashboard-unsubscribe-button" | translate}}</div>
            <div (click)="closeModal()" class="cursor-pointer">{{"common-undo" | translate}}</div>
        </div>
    </ng-container>
</div>